import React from "react";
import { ArrowLeft } from "react-feather";

const BackButton = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      display: "inline-flex", alignItems: "center", gap: 6,
      padding: "7px 14px", borderRadius: 10,
      background: "var(--icon-btn-bg)", border: "1px solid var(--glass-border)",
      color: "var(--text-secondary)", fontSize: "0.8125rem", fontWeight: 600,
      cursor: "pointer", transition: "all 0.15s", lineHeight: 1,
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "rgba(99,102,241,0.1)";
      e.currentTarget.style.color = "var(--brand-indigo)";
      e.currentTarget.style.borderColor = "rgba(99,102,241,0.25)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "var(--icon-btn-bg)";
      e.currentTarget.style.color = "var(--text-secondary)";
      e.currentTarget.style.borderColor = "var(--glass-border)";
    }}
  >
    <ArrowLeft size={15} strokeWidth={2.5} />
    Back
  </button>
);

export default BackButton;
